export default [
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/*webpackChunkName:'login'*/
        '@/pages/LoginCode.vue'),
    meta: {
      anonymous: true
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () =>
      import(/*webpackChunkName:'logout'*/
        '@/pages/Logout.vue'),
    meta: {
      anonymous: true
    }
  }
]
